import React from "react";
import "./ShoppingCartHeading.css";

const ShoppingCartHeading = () => {
  return (
    <div className="ShoppingCartHeading">
      <h2>Shopping Cart</h2>
    </div>
  );
};

export default ShoppingCartHeading;
